module.exports = __webpack_public_path__ + "img/pickFour.42a6c5b8.webp";